__webpack_require__.p = "/assets/turbo/6faf8731/universalat/_next/";